import React from 'react';
import stylesParent from '../../../styles/frame/frame.module.scss';
import styles from '../../../styles/stake/stake-confirm.module.scss';
import Header from '../../../../../../../components/Stake/header';
import OmIcon from '../../../../../../../assets/images/tokens/om.svg';
import theme from '../../../../../../../theme';
import loading from '../../../../../../../assets/images/loading.png';

const MigrateConfirm = () => (
  <>
    <Header icon={OmIcon} title='OM-Migration' />
    <div className={stylesParent.cardContent}>
      <div className={styles.descriptionContainer}>
        <div>
          <img src={loading} className='rotate' alt='' />
        </div>
        <div className={styles.confirm}>
          <span style={{ color: theme.palette.mantra.pink, fontWeight: 800 }}>Confirming...</span>
        </div>
      </div>
    </div>
  </>
);

export default MigrateConfirm;
